export default {
  root: { marginTop: '10px', marginBottom: '10px' },
  noData: {
    margin: '5px 10px'
  },
  phoneLine: {
    width: '200px',
    margin: '5px 10px 5px 0',
    backgroundColor: '#FFF'
  },
  deleteIcon: {
    fontSize: '14px',
    cursor: 'pointer'
  }
};
